import TablaDrivers from "./TablaDrivers";

export default function DriverPygIngresosContent({ empresaId, ejercicios, aniosProyectar, readOnly }) {
  return (
    <TablaDrivers
      empresaId={empresaId}
      ejercicios={ejercicios}
      seccionPyg="ingresos"
      titulo="Driver de Ingresos (PyG)"
      descripcion="Proyección de líneas de 'Importe neto de la cifra de negocios' (partida 1 del PyG)"
      aniosProyectar={aniosProyectar}
      readOnly={readOnly}
      storageKey={`finreport:nivel:${empresaId}:pyg-ingresos`}
    />
  );
}
